/**
 * See operations/registration-or-sign-in/scripts/JScript_sign_in.js -> check_And_Sign_In
 */
export const LoginResult = {
    ACCOUNT_EXPIRED: 7,
    ACCOUNT_LOCKED: 6,
    ACCOUNT_NOT_ACTIVATED: 5,
    ERROR_UNKNOWN: 0,
    INCORRECT_COMBINATION: 4,
    INCORRECT_PASSWORD: 3,
    INCORRECT_USERNAME: 2,
    PROGRESS_REQUEST_REDIRECT: 8,
    SUCCESS: 1,
    SYSTEM_MAINTENANCE: 9
} as const;

export interface LoginResponse {
    loginResult: number;
    attemptsBeforeLockout: number | undefined;
    lockoutDate: Date | undefined;
}

const extractAttemptsBeforeLockout = (body: string): number | undefined => {
    if (parseInt(body.charAt(0)) !== LoginResult.INCORRECT_PASSWORD) return undefined;

    const match = body.match(/\d+\D+(\d+)/);
    return match ? parseInt(match[1]) : undefined;
};

const extractLockoutDate = (body: string): Date | undefined => {
    const match = body.match(/6Account locked - (\d+):(\d{2}) remaining!/);
    if (!match) return undefined;

    const minutes = parseInt(match[1]);
    const seconds = parseInt(match[2]);
    return addSecondsToCurrentDateTime(minutes * 60 + seconds);
};

const addSecondsToCurrentDateTime = (seconds: number): Date => {
    const date = new Date();
    date.setSeconds(date.getSeconds() + seconds);
    return date;
};

export async function login(email: string, password: string): Promise<LoginResponse> {
    try {
        const response = await fetch('/operations/registration-or-sign-in/AJAX-REQUESTS-Registration.asmx/Sign_In', {
            body: JSON.stringify({
                Credentials: {
                    Email: email,
                    Password: password
                }
            }),
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST'
        });

        const body = await response.json();
        const loginResult = parseInt(body.d.charAt(0));
        return {
            attemptsBeforeLockout: extractAttemptsBeforeLockout(body.d),
            lockoutDate: extractLockoutDate(body.d),
            loginResult: loginResult
        };
    } catch (error) {
        console.error(error);
    }

    return {
        attemptsBeforeLockout: undefined,
        lockoutDate: undefined,
        loginResult: LoginResult.ERROR_UNKNOWN
    };
}
